import { mdiHelpCircleOutline } from '@mdi/js'
import { useTranslation } from 'react-i18next'
import { AppIcon } from '../ui/icon'
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'

/**
 * A long explanatory paragraph folded into a help popover: the screen leads
 * with the state and the action, the "why" is one click away.
 */
export function HelpHint({ children, testId }: { children: React.ReactNode; testId: string }) {
    const { t } = useTranslation('assemblies')
    return (
        <Popover>
            <PopoverTrigger
                className="inline-flex align-middle text-muted-foreground hover:text-foreground"
                aria-label={t('help')}
                title={t('help')}
                data-testid={testId}
            >
                <AppIcon path={mdiHelpCircleOutline} size="sm" tone="inherit" />
            </PopoverTrigger>
            <PopoverContent className="max-w-sm text-sm" data-testid={`${testId}-content`}>
                {children}
            </PopoverContent>
        </Popover>
    )
}
